import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, TitleStrategy, withViewTransitions } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { environment } from '../environments/environment';
import { SeoTitleStrategy } from './seo-title-strategy';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

// Token for environment injection (must match the one used in services)
export const ENVIRONMENT_TOKEN = Symbol('ENVIRONMENT');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withViewTransitions()
    ),
    { provide: TitleStrategy, useClass: SeoTitleStrategy },
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    provideAnimationsAsync(),
    // Provide environment for dependency injection
    {
      provide: ENVIRONMENT_TOKEN,
      useValue: environment
    },
    { provide: DateAdapter, useFactory: adapterFactory },
    importProvidersFrom(CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory })),
    provideClientHydration(withEventReplay())
  ]
};
